import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const Bio = () => {
  return (
    <div className="flex flex-col lg:flex-row mt-20 justify-center items-center lg:p-4">
      {/* <StaticImage
        src="../../images/danniel.png"
        alt="Danniel Hansel"
        className="rounded-full w-24 h-24 md:w-36 md:h-36 lg:w-48 lg:h-48  mr-4 md:mr-8"
        placeholder="blurred"
        layout="fullWidth"
        width={150}
        height={150}
      /> */}
      <div className="relative w-1/2 lg:w-full max-w-lg lg:mr-6">
        <div className="mx-auto rounded-full relative w-24 h-24 lg:w-56 lg:h-56">
          <img src="https://res.cloudinary.com/dehanz-dev/image/upload/v1639887422/dannielhansel.com/danniel-headshot-webp-3_nnwn7n.webp" className="object-cover h-full w-full rounded-full ring ring-accent ring-offset-2 lg:ring-offset-4 ring-offset-transparent" alt="Danniel Hansel" />
        </div>
      </div>
      <p className="font-body2 text-xs md:text-2xl mt-8 lg:mt-0">
        Hey there 👋, I'm{" "}
        <a
          href="https://mobile.twitter.com/dehanz13"
          rel="noreferrer noopener"
          target="_blank"
          className="text-accent"
        >
          Danniel
        </a>
        . I'm passionate about technology, solving problems, design and research. This site, is like me! It's a work in progress, so you'll see things come and go as I learn and change based on new information.
      </p>
    </div>
  )
}
export default Bio
